import { createVisibleItemOffersAtom } from "../create-visible-catalog-atoms";
import indoorCategoriesAtom from "./categories";
import indoorItemOffersAtom from "./item-offers";

/** INDOOR offers searchable right now (offer window + owning category window). */
const indoorVisibleItemOffersAtom = createVisibleItemOffersAtom(
  indoorCategoriesAtom,
  indoorItemOffersAtom,
);

export default indoorVisibleItemOffersAtom;
